import React from 'react'
import { Form } from 'react-bootstrap'
import { Typeahead } from 'react-bootstrap-typeahead'
import useStudents from '../../../hooks/use-students'
import gradeNumber from '../../../utilities/grade-number'
import { first } from 'lodash'

const StudentParam = ({
    label,
    value,
    onChange = () => {}
}) => {

    const mapStudent = (s) => {
        const {
            id,
            firstName,
            lastName,
            gradYear
        } = s
        const grade = gradeNumber(gradYear)
        return {
            id,
            label: `${firstName} ${lastName} - ${grade}`
        }
    }
    
    const [search, setSearch] = React.useState()
    const {
        isLoading,
        students
    } = useStudents({
        limit: 10,
        search: search
    })

    console.log('students:', students)
    const options = students.map(mapStudent)

    const onChanged = React.useCallback((users = []) => {
        const user = first(users)
        onChange(user ? user.id : undefined)
    }, [onChange])

    const selected = students.filter(s => s.id === value).map(mapStudent)
    //onInputChange={setSearch}
    return (
        <Form.Group>
            <Form.Label>{label || 'School Year'}</Form.Label>
            <Typeahead
                placeholder='Search for student...'
                filterBy={() => true}
                clearButton
                id={label}
                onChange={onChanged}
                options={options}
                minLength={3}
                onInputChange={setSearch}
                onSearch={(searchString) => console.log('searchString:', searchString)}
                isLoading={isLoading}
            />
        </Form.Group>
    )
}

export default StudentParam